import React, { Fragment, useEffect } from 'react';
import styles from './PopupStatistics.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { deleteStatisticsRedux } from '../../store/slices/showPopupStatisticsSlice';
import { bodyScrollOverflowAuto } from '../../helper';
import { useParams } from 'react-router-dom';

export default function PopupStatistics() {
  let { group_id } = useParams();

  const dispatch = useDispatch();
  const statistics = useSelector((state) => state.showPopupStatistics.statistics);

  //Закриває попап
  const closedPopup = () => {
    dispatch(deleteStatisticsRedux());
    bodyScrollOverflowAuto();
  };

  useEffect(() => {
    // При розмонтовувані компонента повертаєм скрол body і обнуляєм обєкт статистики
    return () => {
      bodyScrollOverflowAuto();
      dispatch(deleteStatisticsRedux());
    };
  }, []);

  const getCompareItems = (items) => {
    return items.map((item) => {
      return (
        <Fragment key={item.id}>
          <div className={item.date ? styles.body_element : ''}>{item.date ? item.date : ''}</div>
          <div className={item.date_time ? styles.body_element : ''}>
            {item.date_time ? item.date_time : ''}
          </div>
          <div className={styles.body_element}>{item.kg}</div>
          <div className={styles.body_element}>{item.breastVolumes}</div>
          <div className={styles.body_element}>{item.handVolumes}</div>
          <div className={styles.body_element}>{item.waistVolumes}</div>
          <div className={styles.body_element}>{item.abdominalVolumes}</div>
          <div className={styles.body_element}>{item.thighVolumes}</div>
          <div className={styles.body_element}>{item.legVolumes}</div>
          <div className={styles.body_element + ' ' + styles.body_element_active_color}>
            {item.totalVolume}
          </div>
        </Fragment>
      );
    });
  };

  const renderResultValue = (item, unit, classCss = '') => {
    return (
      <div
        className={
          item >= 0
            ? styles.body_element + ' ' + classCss + ' ' + styles.plus
            : styles.body_element + ' ' + classCss + ' ' + styles.minus
        }>
        {item >= 0
          ? Number.isInteger(Number(item.toFixed(1)))
            ? '-' + item + ' ' + unit
            : '-' + item.toFixed(1) + ' ' + unit
          : item !== '-'
          ? item === 0
            ? item.toFixed(1) + ' ' + unit
            : '+' + Math.abs(item.toFixed(1)) + ' ' + unit
          : item}
      </div>
    );
  };

  const getCompareItemsValue = (compareItems) => {
    return compareItems.map((item) => {
      return (
        <Fragment key={item.id}>
          <div></div>
          <div></div>
          {renderResultValue(item.kg, 'кг', styles.body_element_active_color)}

          {renderResultValue(item.breastVolumes, 'см')}
          {renderResultValue(item.handVolumes, 'см')}
          {renderResultValue(item.waistVolumes, 'см')}
          {renderResultValue(item.abdominalVolumes, 'см')}
          {renderResultValue(item.thighVolumes, 'см')}
          {renderResultValue(item.legVolumes, 'см')}

          {renderResultValue(item.totalVolume, 'см', styles.body_element_active_color)}
        </Fragment>
      );
    });
  };
  const getCompareValue = (compareItems) => {
    let values = [
      {
        id: compareItems[0].id + compareItems[1].id,
        kg:
          compareItems[0].kg !== '' && compareItems[1].kg !== ''
            ? compareItems[0].kg - compareItems[1].kg
            : '-',
        breastVolumes:
          compareItems[0].breastVolumes !== '' && compareItems[1].breastVolumes !== ''
            ? compareItems[0].breastVolumes - compareItems[1].breastVolumes
            : '-',
        handVolumes:
          compareItems[0].handVolumes !== '' && compareItems[1].handVolumes !== ''
            ? compareItems[0].handVolumes - compareItems[1].handVolumes
            : '-',
        waistVolumes:
          compareItems[0].waistVolumes !== '' && compareItems[1].waistVolumes !== ''
            ? compareItems[0].waistVolumes - compareItems[1].waistVolumes
            : '-',
        abdominalVolumes:
          compareItems[0].abdominalVolumes !== '' && compareItems[1].abdominalVolumes !== ''
            ? compareItems[0].abdominalVolumes - compareItems[1].abdominalVolumes
            : '-',
        thighVolumes:
          compareItems[0].thighVolumes !== '' && compareItems[1].thighVolumes !== ''
            ? compareItems[0].thighVolumes - compareItems[1].thighVolumes
            : '-',
        legVolumes:
          compareItems[0].legVolumes !== '' && compareItems[1].legVolumes !== ''
            ? compareItems[0].legVolumes - compareItems[1].legVolumes
            : '-',
        totalVolume:
          compareItems[0].totalVolume !== '' &&
          compareItems[0].totalVolume !== '-' &&
          compareItems[1].totalVolume !== '' &&
          compareItems[1].totalVolume !== '-'
            ? compareItems[0].totalVolume - compareItems[1].totalVolume
            : '-',
      },
    ];

    return values;
  };

  // Відбрирає статистику групи в якій находимось
  const getGroupMeasurements = (measurements) => {
    // const groupMeasurements = measurements.filter((item) => {
    //   return item.group_id === group_id;
    // });
    // return groupMeasurements;
    for (let index = 0; index < measurements.length; index++) {
      const item = measurements[index];
      if (item.group_id === group_id) {
        return measurements;
      }
    }

    return [];
  };

  const renderMeasurements = (items) => {
    return (
      <div className={styles.compare_wrapper}>
        <div className={styles.body_item_title}></div>
        <div className={styles.body_item_title}></div>
        <div className={styles.body_item_title}>Вага</div>
        <div className={styles.body_item_title}>Об'єм грудей</div>
        <div className={styles.body_item_title}>Об'єм руки</div>
        <div className={styles.body_item_title}>Об'єм талії</div>
        <div className={styles.body_item_title}>Об'єм живота</div>
        <div className={styles.body_item_title}>Об'єм стегон</div>
        <div className={styles.body_item_title}>Об'єм ноги</div>
        <div>Серд. об'єм</div>

        {items.length ? getCompareItems(items) : ''}
        {items.length > 1 ? getCompareItemsValue(getCompareValue(items)) : ''}
      </div>
    );
  };

  const getSortMeasurementsArray = (measurementsArray) => {
    if (measurementsArray.length === 1) {
      return [measurementsArray];
    }
    let sortMeasurementsArray = [];
    for (let index = 0; index < measurementsArray.length; index++) {
      if (measurementsArray[index + 1]) {
        sortMeasurementsArray.push([measurementsArray[index], measurementsArray[index + 1]]);
      }
    }
    if (measurementsArray.length > 2) {
      sortMeasurementsArray.push([
        { ...measurementsArray[0], id: new Date().getTime() + 1, report: true },
        {
          ...measurementsArray[measurementsArray.length - 1],
          id: new Date().getTime() + 2,
          report: true,
        },
      ]);
    }
    // return sortMeasurementsArray;
    return sortMeasurementsArray.reverse();
  };

  const renderBlockMeasurements = (measurementsProps) => {
    const measurements = getGroupMeasurements(measurementsProps);

    return getSortMeasurementsArray(measurements).map((item, index) => {
      return (
        <div key={item[0].id}>
          {item[0].report ? (
            <div style={{ marginBottom: 10, color: 'green' }}>
              Віднімає перший замір від останього.
            </div>
          ) : item.length > 1 ? (
            <div style={{ marginBottom: 10 }}>
              Порівняння №{measurements.length === 2 ? 1 : measurements.length - index}
            </div>
          ) : (
            ''
          )}

          {renderMeasurements(item)}
        </div>
      );
    });
  };

  return Object.keys(statistics).length ? (
    <div className={styles.popup_wrapper}>
      <button className={styles.popup_close_btn} onClick={() => closedPopup()}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">
          <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
        </svg>
      </button>
      <div className={styles.popup_content_wrapper}>
        <div className={styles.popup_client_fullName}>{statistics.fullName}</div>
        <div className={styles.measurements_wrapper}>
          {renderBlockMeasurements(statistics.measurements)}
        </div>
      </div>
    </div>
  ) : (
    ''
  );
}
